import { getFormValues } from 'redux-form'
import { getAppointments } from 'selectors/getAppointments'
import {
  APPOINTMENT_FORM_NAME,
  VEHICLE_SELECTOR_TARGET_ID,
  LOCATION_SELECTOR_TARGET_ID,
  SERVICES_SELECTOR_TARGET_ID,
  DATE_TIME_SELECTOR_TARGET_ID
} from 'constant'

export const getAppointmentFormValues = getFormValues(APPOINTMENT_FORM_NAME)

export const getCompletedSteps = state => {
  const { activeVehicleId, selectedStore, catalogRefIds, appointmentDate } = getAppointmentFormValues(state) || {}
  const { isTrailer } = getAppointments(state)
  return [
    {
      isDone: Boolean(activeVehicleId || isTrailer),
      targetId: VEHICLE_SELECTOR_TARGET_ID
    },
    {
      isDone: Boolean(selectedStore),
      targetId: LOCATION_SELECTOR_TARGET_ID
    },
    {
      isDone: Boolean(catalogRefIds && catalogRefIds.length),
      targetId: SERVICES_SELECTOR_TARGET_ID
    },
    {
      isDone: Boolean(appointmentDate && appointmentDate.time),
      targetId: DATE_TIME_SELECTOR_TARGET_ID
    }
  ]
}

export const checkIsAllStepsCompeted = steps => steps.every(({ isDone }) => isDone)
